import React from 'react'
import { Input } from 'antd'
import { Draggable, Droppable } from 'react-beautiful-dnd'
import { Icon } from '@iconify/react'

import styles from './EpicHeaderRow.module.css'

const EPIC_TITLE_MAX_CHARS = 42

const truncateEpicTitle = (title = '', max = EPIC_TITLE_MAX_CHARS) => {
    const raw = String(title || '').trim()
    if (raw.length <= max) return raw
    return `${raw.slice(0, max).trimEnd()}...`
}

const EpicHeaderRow = ({
    epicHScrollRef,
    syncHorizontalScroll,
    epicGridStyle,
    epicsForBoard,
    EPIC_CREATE_DRAFT_ID,
    createEpicUi,
    epicEdit,
    handleEpicCardMouseMove,
    handleEpicCardMouseLeave,
    createEpicInputRef,
    createEpicSubmitting,
    setCreateEpicUi,
    submitCreateEpic,
    closeCreateEpic,
    epicTitleEditContainerRef,
    epicTitleEditRef,
    epicEditSubmitting,
    setEpicEdit,
    submitEpicTitleEdit,
    openEpicTitleEdit,
    epicInsertHover,
    openCreateEpicAt,
}) => (
    <div className={styles.epicHeaderRow}>
        <div
            ref={epicHScrollRef}
            className={styles.epicRowScroll}
            onScroll={(e) => syncHorizontalScroll(e.currentTarget)}
        >
            <Droppable
                droppableId="epics-row"
                direction="horizontal"
                type="epic"
            >
                {(provided) => (
                    <div
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                        className={styles.epicRow}
                        style={epicGridStyle}
                    >
                        {epicsForBoard.map((epic, index) => {
                            const isCreateDraft =
                                epic.id === EPIC_CREATE_DRAFT_ID
                            return (
                                <Draggable
                                    key={epic.id}
                                    draggableId={`epic-${epic.id}`}
                                    index={index}
                                    isDragDisabled={
                                        !!createEpicUi ||
                                        !!epicEdit ||
                                        isCreateDraft
                                    }
                                >
                                    {(epicProvided) => (
                                        <div
                                            ref={epicProvided.innerRef}
                                            {...epicProvided.draggableProps}
                                            className={styles.epicCardWrap}
                                            onMouseMove={
                                                isCreateDraft
                                                    ? undefined
                                                    : (e) =>
                                                          handleEpicCardMouseMove(
                                                              e,
                                                              epic.id
                                                          )
                                            }
                                            onMouseLeave={
                                                isCreateDraft
                                                    ? undefined
                                                    : handleEpicCardMouseLeave
                                            }
                                        >
                                            {isCreateDraft ? (
                                                <div
                                                    {...epicProvided.dragHandleProps}
                                                    className={
                                                        styles.createEpicCard
                                                    }
                                                >
                                                    <Input.TextArea
                                                        ref={createEpicInputRef}
                                                        className={
                                                            styles.createEpicInput
                                                        }
                                                        classNames={{
                                                            textarea:
                                                                styles.epicTitleTextareaInner,
                                                        }}
                                                        placeholder="Epic title"
                                                        value={
                                                            createEpicUi?.title ??
                                                            ''
                                                        }
                                                        disabled={
                                                            createEpicSubmitting
                                                        }
                                                        onChange={(e) => {
                                                            const v =
                                                                e.target.value
                                                            setCreateEpicUi(
                                                                (prev) =>
                                                                    prev
                                                                        ? {
                                                                              ...prev,
                                                                              title: v,
                                                                          }
                                                                        : prev
                                                            )
                                                        }}
                                                        onKeyDown={(e) => {
                                                            if (
                                                                e.key !==
                                                                    'Enter' ||
                                                                e.shiftKey
                                                            )
                                                                return
                                                            e.preventDefault()
                                                            const t = (
                                                                createEpicUi?.title ||
                                                                ''
                                                            ).trim()
                                                            if (!t) return
                                                            submitCreateEpic()
                                                        }}
                                                        rows={1}
                                                    />
                                                    <div
                                                        className={
                                                            styles.createEpicFooter
                                                        }
                                                    >
                                                        <div
                                                            className={
                                                                styles.createEpicFooterIcons
                                                            }
                                                        >
                                                            <Icon
                                                                icon="mdi:flash"
                                                                width={18}
                                                            />
                                                        </div>
                                                        <div
                                                            className={
                                                                styles.createEpicFooterActions
                                                            }
                                                        >
                                                            <button
                                                                type="button"
                                                                className={
                                                                    styles.createEpicIconBtn
                                                                }
                                                                title="Cancel"
                                                                disabled={
                                                                    createEpicSubmitting
                                                                }
                                                                onClick={
                                                                    closeCreateEpic
                                                                }
                                                            >
                                                                <Icon
                                                                    icon="mdi:close"
                                                                    width={16}
                                                                />
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className={
                                                                    styles.createEpicIconBtn
                                                                }
                                                                title="Create epic"
                                                                disabled={
                                                                    createEpicSubmitting ||
                                                                    !(
                                                                        createEpicUi?.title ||
                                                                        ''
                                                                    ).trim()
                                                                }
                                                                onClick={() =>
                                                                    submitCreateEpic()
                                                                }
                                                            >
                                                                <Icon
                                                                    icon="mdi:check"
                                                                    width={16}
                                                                />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : (
                                                <>
                                                    <div
                                                        {...epicProvided.dragHandleProps}
                                                        className={
                                                            styles.epicCard
                                                        }
                                                    >
                                                        {epicEdit?.epicId ===
                                                        epic.id ? (
                                                            <div
                                                                ref={
                                                                    epicTitleEditContainerRef
                                                                }
                                                                className={
                                                                    styles.epicTitleEditWrap
                                                                }
                                                                onMouseDown={(
                                                                    e
                                                                ) =>
                                                                    e.stopPropagation()
                                                                }
                                                            >
                                                                <Input.TextArea
                                                                    ref={
                                                                        epicTitleEditRef
                                                                    }
                                                                    className={
                                                                        styles.createEpicInput
                                                                    }
                                                                    classNames={{
                                                                        textarea:
                                                                            styles.epicTitleTextareaInner,
                                                                    }}
                                                                    value={
                                                                        epicEdit.title
                                                                    }
                                                                    disabled={
                                                                        epicEditSubmitting
                                                                    }
                                                                    onChange={(
                                                                        e
                                                                    ) => {
                                                                        const v =
                                                                            e
                                                                                .target
                                                                                .value
                                                                        setEpicEdit(
                                                                            (
                                                                                prev
                                                                            ) =>
                                                                                prev
                                                                                    ? {
                                                                                          ...prev,
                                                                                          title: v,
                                                                                      }
                                                                                    : prev
                                                                        )
                                                                    }}
                                                                    onKeyDown={(
                                                                        e
                                                                    ) => {
                                                                        if (
                                                                            e.key ===
                                                                            'Escape'
                                                                        ) {
                                                                            e.preventDefault()
                                                                            setEpicEdit(
                                                                                null
                                                                            )
                                                                            return
                                                                        }
                                                                        if (
                                                                            e.key !==
                                                                                'Enter' ||
                                                                            e.shiftKey
                                                                        )
                                                                            return
                                                                        e.preventDefault()
                                                                        const t =
                                                                            (
                                                                                epicEdit.title ||
                                                                                ''
                                                                            ).trim()
                                                                        if (!t)
                                                                            return
                                                                        submitEpicTitleEdit()
                                                                    }}
                                                                    rows={1}
                                                                />
                                                            </div>
                                                        ) : (
                                                            <div
                                                                role="presentation"
                                                                className={
                                                                    styles.epicTitle
                                                                }
                                                                title={epic.title}
                                                                onMouseDown={(
                                                                    e
                                                                ) =>
                                                                    e.stopPropagation()
                                                                }
                                                                onClick={(
                                                                    e
                                                                ) => {
                                                                    e.stopPropagation()
                                                                    openEpicTitleEdit(
                                                                        epic
                                                                    )
                                                                }}
                                                            >
                                                                {truncateEpicTitle(
                                                                    epic.title
                                                                )}
                                                            </div>
                                                        )}
                                                        <div
                                                            className={
                                                                styles.epicCardFooter
                                                            }
                                                        >
                                                            <div
                                                                className={
                                                                    styles.createEpicFooterIcons
                                                                }
                                                            >
                                                                <Icon
                                                                    icon="mdi:flash"
                                                                    width={18}
                                                                />
                                                            </div>
                                                            {epic.epicKey ? (
                                                                <span
                                                                    className={
                                                                        styles.epicMeta
                                                                    }
                                                                >
                                                                    {
                                                                        epic.epicKey
                                                                    }
                                                                </span>
                                                            ) : (
                                                                <span
                                                                    aria-hidden
                                                                />
                                                            )}
                                                        </div>
                                                    </div>
                                                    {epicInsertHover?.id ===
                                                        epic?.id &&
                                                        !createEpicUi && (
                                                            <div
                                                                className={
                                                                    styles.epicInsertRail
                                                                }
                                                                data-side={
                                                                    epicInsertHover.side
                                                                }
                                                                aria-hidden
                                                            >
                                                                <button
                                                                    type="button"
                                                                    className={
                                                                        styles.epicInsertBtn
                                                                    }
                                                                    title="Add epic"
                                                                    onMouseDown={(
                                                                        ev
                                                                    ) => {
                                                                        ev.stopPropagation()
                                                                    }}
                                                                    onClick={(
                                                                        ev
                                                                    ) => {
                                                                        ev.stopPropagation()
                                                                        if (
                                                                            epicInsertHover?.id !==
                                                                            epic.id
                                                                        )
                                                                            return
                                                                        openCreateEpicAt(
                                                                            index,
                                                                            epicInsertHover.side
                                                                        )
                                                                    }}
                                                                >
                                                                    +
                                                                </button>
                                                                <div
                                                                    className={
                                                                        styles.epicInsertLine
                                                                    }
                                                                />
                                                            </div>
                                                        )}
                                                </>
                                            )}
                                        </div>
                                    )}
                                </Draggable>
                            )
                        })}
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </div>
    </div>
)

export default EpicHeaderRow
